import { TASK_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
  getProjectBoardsLoading: false,
  getProjectBoardsSuccess: false,
  getProjectBoardsFailure: false,
  getProjectBoardsError: null,

  getNextProjectTaskBoardsLoading: false,
  getNextProjectTaskBoardsSuccess: false,
  getNextProjectTaskBoardsFailure: false,
  getNextProjectTaskBoardsError: null,

  getTaskboardStatusLoading: false,
  getTaskboardStatusSuccess: false,
  getTaskboardStatusFailure: false,
  getTaskboardStatusError: null,

  createTaskboardLoading: false,
  createTaskboardSuccess: false,
  createTaskboardFailure: false,
  createTaskboardError: null,

  editTaskboardLoading: false,
  editTaskboardSuccess: false,
  editTaskboardFailure: false,
  editTaskboardError: null,

  editTaskLoading: false,
  editTaskSuccess: false,
  editTaskFailure: false,
  editTaskError: null,

  updateTaskStatusLoading: false,
  updateTaskStatusSuccess: false,
  updateTaskStatusFailure: false,
  updateTaskStatusError: null,

  addTaskLoading: false,
  addTaskSuccess: false,
  addTaskFailure: false,
  addTaskError: null,

  deleteTaskLoading: false,
  deleteTaskSuccess: false,
  deleteTaskFaiure: false,
  deleteTaskError: null,

  deleteTaskboardLoading: false,
  deleteTaskboardSuccess: false,
  deleteTaskboardFailure: false,
  deleteTaskboardError: null,

  addBoardModal: false,
  inviteModal: false,

  sentInviteLoading: false,
  sendInviteSuccess: false,
  sentInviteFailure: false,
  sendInviteError: null,

  removeEmployeeLoading: false,
  removeEmployeeSuccess: false,
  removeEmployeeFailure: false,
  removeEmployeeError: null,

  getQaTemplateLoading: false,
  getQaTemplateSuccess: false,
  getQaTemplateFailure: false,
  getQaTemplateError: null,
  QaTemplates: [],

  addQaTemplateLoading: false,
  addQaTemplateSuccess: false,
  addQaTemplateFailure: false,
  addQaTemplateError: null,

  deleteQaTemplateLoading: false,
  deleteQaTemplateSuccess: false,
  deleteQaTemplateFailure: false,
  deleteQaTemplateError: null,

  userListForInviteLoading: false,
  userListForInviteSuccess: false,
  userListForInviteFailure: false,
  userListForInviteError: null,

  updateQaTemplateLoading: false,
  updateQaTemplateSuccess: false,
  updateQaTemplateFailure: false,
  updateQaTemplateError: null,

  getCommentInKanbanLoading: false,
  getCommentInKanbanSuccess: false,
  getCommentInKanbanFailure: false,
  getCommentInKanbanError: null,

  addCommentInKanbanLoading: false,
  addCommentInKanbanSuccess: false,
  addCommentInKanbanFailure: false,
  addCommentInKanbanError: null,

  deleteCommentInKanbanLoading: false,
  deleteCommentInKanbanSuccess: false,
  deleteCommentInKanbanFailure: false,
  deleteCommentInKanbanError: null,

  getTaskWorkHistoryLoading: false,
  getTaskWorkHistorySuccess: false,
  getTaskWorkHistoryFailure: false,
  getTaskWorkHistoryError: null,

  getTaskWorkLogLoading: false,
  getTaskWorkLogSuccess: false,
  getTaskWorkLogFailure: false,
  getTaskWorkLogError: null,

  addTaskWorkLogSuccess: false,
  addTaskWorkLogLoading: false,
  addTaskWorkLogFailure: false,
  addTaskWorkLogError: null,

  deleteTaskAttachmentSuccess: false,
  deleteTaskAttachmentLoading: false,
  deleteTaskAttachmentFailure: false,
  deleteTaskAttachmentError: null,

  updateBoardOrderLoading: false,
  selectedProject: "",
  projectBoards: [],
  filteredProjectBoards: [],
  taskboardStatus: [],
  TaskHistory: [],
  TaskWorkLog: [],
  // QaTemplates: [
  //   {
  //     testCaseId: 1,
  //     title: "login test case ",
  //     severity: "low",
  //     severityId: 1,
  //     testTypeId: 35,
  //     status: null,
  //     statusTypeId: 1,
  //   },
  //   {
  //     testCaseId: 2,
  //     title: "sign up test case",
  //     severity: "low",
  //     severityId: 1,
  //     testTypeId: 37,
  //     status: null,
  //     statusTypeId: 2,
  //   },
  //   {
  //     testCaseId: 3,
  //     title: "forgot Password test case",
  //     severity: "low",
  //     severityId: 1,
  //     testTypeId: 36,
  //     status: null,
  //     statusTypeId: 3,
  //   },
  //   {
  //     testCaseId: 4,
  //     title: "login test case",
  //     severity: "low",
  //     severityId: 1,
  //     testTypeId: 35,
  //     status: null,
  //     statusTypeId: 1,
  //   },
  //   {
  //     testCaseId: 5,
  //     title: "sign up test case",
  //     severity: "low",
  //     severityId: 1,
  //     testTypeId: 37,
  //     status: null,
  //     statusTypeId: 2,
  //   },
  //   {
  //     testCaseId: 6,
  //     title: "forgot Password test case",
  //     severity: "low",
  //     severityId: 1,
  //     testTypeId: 36,
  //     status: null,
  //     statusTypeId: 3,
  //   },
  //   {
  //     testCaseId: 7,
  //     title: "login test case",
  //     severity: "low",
  //     severityId: 1,
  //     testTypeId: 35,
  //     status: null,
  //     statusTypeId: 1,
  //   },
  //   {
  //     testCaseId: 8,
  //     title: "sign up test case",
  //     severity: "low",
  //     severityId: 1,
  //     testTypeId: 37,
  //     status: null,
  //     statusTypeId: 2,
  //   },
  //   {
  //     testCaseId: 9,
  //     title: "forgot Password test case",
  //     severity: "low",
  //     severityId: 1,
  //     testTypeId: 36,
  //     status: null,
  //     statusTypeId: 3,
  //   },
  //   {
  //     testCaseId: 10,
  //     title: "login test case",
  //     severity: "low",
  //     severityId: 1,
  //     testTypeId: 35,
  //     status: null,
  //     statusTypeId: 1,
  //   },
  //   {
  //     testCaseId: 11,
  //     title: "sign up test case",
  //     severity: "low",
  //     severityId: 1,
  //     testTypeId: 37,
  //     status: null,
  //     statusTypeId: 2,
  //   },
  // ],
  userListforInvites: [],
  addTaskModals: false,
};

export const taskReducer = (state = INITIAL_STATE, action) => {
  let allTasks, new_col, qa;
  switch (action.type) {
    case TASK_REQUEST.GET_PROJECT_BOARDS_REQUEST:
      return {
        ...state,
        getProjectBoardsLoading: true,
        getProjectBoardsSuccess: false,
        getProjectBoardsFailure: false,
        getProjectBoardsError: null,
      };
    case TASK_REQUEST.GET_PROJECT_BOARDS_SUCCESS:
      if (action.payload != null) {
        for (let index = 0; index < action.payload.length; index++) {
          if (!action.payload[index].cards) action.payload[index].cards = [];
        }
      }
      return {
        ...state,
        getProjectBoardsLoading: false,
        getProjectBoardsSuccess: true,
        getProjectBoardsFailure: false,
        getProjectBoardsError: null,
        projectBoards: { columns: action.payload },
        filteredProjectBoards: { columns: action.payload },
      };
    case TASK_REQUEST.GET_PROJECT_BOARDS_FAILURE:
      return {
        ...state,
        getProjectBoardsLoading: false,
        getProjectBoardsSuccess: false,
        getProjectBoardsFailure: true,
        getProjectBoardsError: action.payload,
      };

    // update task board move

    case TASK_REQUEST.UPDATE_TASK_BOARDS_ORDER_REQUEST:
      return {
        ...state,
        updateBoardOrderLoading: true,
      };

    case TASK_REQUEST.UPDATE_TASK_BOARDS_ORDER_SUCCESS:
      return {
        ...state,
        updateBoardOrderLoading: false,
      };

    case TASK_REQUEST.UPDATE_TASK_BOARDS_ORDER_FAILURE:
      return {
        ...state,
        updateBoardOrderLoading: false,
      };

    case TASK_REQUEST.UPDATE_MILESTONE_TASK_COUNTS: {
      console.log("/// it is hit");
      console.log("Updating milestone task counts", action.payload);
      console.log("Current selected milestone", state.selectedMilestone);
      console.log("filteredProjectBoards", state.filteredProjectBoards);
      const updatedMilestone = { ...state.selectedMilestone }; // or wherever you store milestone

      const from = action.payload.sourceStatus; // "Todo", "InProgress", "Done" etc.
      const to = action.payload.destinationStatus;

      // Decrement from
      if (from === "ToDo") updatedMilestone.toDoMilestoneTasks--;
      else if (from === "InProgress")
        updatedMilestone.inProgressMilestoneTasks--;
      else if (from === "Done") updatedMilestone.completedMilestoneTasks--;

      // Increment to
      if (to === "ToDo") updatedMilestone.toDoMilestoneTasks++;
      else if (to === "InProgress") updatedMilestone.inProgressMilestoneTasks++;
      else if (to === "Done") updatedMilestone.completedMilestoneTasks++;

      return {
        ...state,
        selectedMilestone: updatedMilestone,
      };
    }

    //working hours

    case TASK_REQUEST.GET_WORKING_HOURS_REQUEST:
      return {
        ...state,
        getWorkingHoursLoading: true,
        getWorkingHoursSuccess: false,
        getWorkingHoursFailure: false,
        getWorkingHoursError: null,
      };

    case TASK_REQUEST.GET_WORKING_HOURS_SUCCESS:
      return {
        ...state,
        getWorkingHoursLoading: false,
        getWorkingHoursSuccess: true,
        getWorkingHoursFailure: false,
        getWorkingHoursError: null,
        workingHours: action.payload, // ✅ Store working hours data
      };

    case TASK_REQUEST.GET_WORKING_HOURS_FAILURE:
      return {
        ...state,
        getWorkingHoursLoading: false,
        getWorkingHoursSuccess: false,
        getWorkingHoursFailure: true,
        getWorkingHoursError: action.payload,
      };

    //next Board Task
    case TASK_REQUEST.GET_NEXT_PROJECT_TASK_BOARDS_REQUEST:
      return {
        ...state,
        getNextProjectTaskBoardsLoading: true,
        getNextProjectTaskBoardsSuccess: false,
        getNextProjectTaskBoardsFailure: false,
        getNextProjectTaskBoardsError: null,
      };
    case TASK_REQUEST.GET_NEXT_PROJECT_TASK_BOARDS_SUCCESS:
      if (action.payload != null && action.payload.length > 0) {
        for (
          let index = 0;
          index < state.projectBoards.columns.length;
          index++
        ) {
          if (
            state.projectBoards.columns[index].id ===
            action.payload[0].currentTaskBoardId
          ) {
            state.projectBoards.columns[index].cards = [
              ...state.projectBoards.columns[index].cards,
              ...action.payload,
            ];
            state.getNextProjectTaskBoardsSuccess = true;
            break;
          }
        }
      }
      return {
        ...state,
        getNextProjectTaskBoardsLoading: false,
        getNextProjectTaskBoardsFailure: false,
        getNextProjectTaskBoardsError: null,
        filteredProjectBoards: state.projectBoards,
      };
    case TASK_REQUEST.GET_NEXT_PROJECT_TASK_BOARDS_FAILURE:
      return {
        ...state,
        getNextProjectTaskBoardsLoading: false,
        getNextProjectTaskBoardsSuccess: false,
        getNextProjectTaskBoardsFailure: true,
        getNextProjectTaskBoardsError: action.payload,
      };

    case TASK_REQUEST.CLEAR_TASK:
      return {
        ...state,
        projectBoards: { columns: [] },
        filteredProjectBoards: { columns: [] },
        getProjectBoardsLoading: false,
        getProjectBoardsSuccess: false,
        getProjectBoardsFailure: false,
        getProjectBoardsError: null,
        getNextProjectTaskBoardsLoading: false,
        getNextProjectTaskBoardsSuccess: false,
        getNextProjectTaskBoardsFailure: false,
        getNextProjectTaskBoardsError: null,
      };

    case TASK_REQUEST.OPEN_ADD_BOARD_MODAL:
      return {
        ...state,
        addBoardModal: true,
      };
    case TASK_REQUEST.CLOSE_ADD_BOARD_MODAL:
      return {
        ...state,
        addBoardModal: false,
      };
    case TASK_REQUEST.GET_TASK_BOARD_STATUS_REQUEST:
      return {
        ...state,
        getTaskboardStatusLoading: true,
        getTaskboardStatusSuccess: false,
        getTaskboardStatusFailure: false,
        getTaskboardStatusError: null,
      };
    case TASK_REQUEST.GET_TASK_BOARD_STATUS_SUCCESS:
      return {
        ...state,
        getTaskboardStatusLoading: false,
        getTaskboardStatusSuccess: true,
        getTaskboardStatusFailure: false,
        getTaskboardStatusError: null,
        taskboardStatus: action.payload,
      };
    case TASK_REQUEST.GET_TASK_BOARD_STATUS_FAILURE:
      return {
        ...state,
        getTaskboardStatusLoading: false,
        getTaskboardStatusSuccess: false,
        getTaskboardStatusFailure: true,
        getTaskboardStatusError: action.payload,
      };
    case TASK_REQUEST.CREATE_TASK_BOARD_REQUEST:
      return {
        ...state,
        createTaskboardLoading: true,
        createTaskboardSuccess: false,
        createTaskboardFailure: false,
        createTaskboardError: null,
      };
    case TASK_REQUEST.CREATE_TASK_BOARD_SUCCESS:
      // allTasks = state.projectBoards;
      // allTasks.columns.push({
      //   id: action.payload.taskBoardId,
      //   title: action.payload.title,
      //   taskBoardStatusId: action.payload.taskBoardStatusId,
      //   cards: [],
      // });
      return {
        ...state,
        createTaskboardLoading: false,
        createTaskboardSuccess: true,
        createTaskboardFailure: false,
        createTaskboardError: null,
        projectBoards: action.payload,
        filteredProjectBoards: action.payload,
        // projectBoards: allTasks,
        // filteredProjectBoards: allTasks,
      };
    case TASK_REQUEST.CREATE_TASK_BOARD_FAILURE:
      return {
        ...state,
        createTaskboardLoading: false,
        createTaskboardSuccess: false,
        createTaskboardFailure: true,
        createTaskboardError: action.payload,
      };
    case TASK_REQUEST.EDIT_TASK_BOARD_REQUEST:
      return {
        ...state,
        editTaskboardLoading: true,
        editTaskboardSuccess: false,
        editTaskboardFailure: false,
        editTaskboardError: null,
      };
    case TASK_REQUEST.EDIT_TASK_BOARD_SUCCESS:
      // let boards_ = state.projectBoards;
      // for (let i = 0; i < boards_.columns.length; i++) {
      //   if (boards_.columns[i].id === action.payload.taskBoardId) {
      //     boards_.columns[i].taskBoardStatusId =
      //       action.payload.taskBoardStatusId;
      //     boards_.columns[i].title = action.payload.title;
      //   }
      // }
      return {
        ...state,
        editTaskboardLoading: false,
        editTaskboardSuccess: true,
        editTaskboardFailure: false,
        editTaskboardError: null,
        projectBoards: action.payload,
        filteredProjectBoards: action.payload,
        // projectBoards: boards_,
        // filteredProjectBoards: boards_,
      };
    case TASK_REQUEST.EDIT_TASK_BOARD_FAILURE:
      return {
        ...state,
        editTaskboardLoading: false,
        editTaskboardSuccess: false,
        editTaskboardFailure: true,
        editTaskboardError: action.payload,
      };
    case TASK_REQUEST.EDIT_TASK_REQUEST:
      return {
        ...state,
        editTaskLoading: true,
        editTaskSuccess: false,
        editTaskFailure: false,
        editTaskError: null,
      };
    // case TASK_REQUEST.EDIT_TASK_SUCCESS:
    //   if (action.info != null)
    //     state.projectBoards.columns[action.info.boardIndex].cards[
    //       action.info.taskIndex
    //     ] = {
    //       ...action.payload,
    //       taskDocuments: action.payload.taskDocumentsResp,
    //     };
    //   else {
    //     let boards = state.projectBoards.columns;
    //     let boardIndex = -1;
    //     let taskIndex = -1;
    //     for (let index = 0; index < boards.length; index++) {
    //       if (boards[index].id === action.payload.currentTaskBoardId) {
    //         boardIndex = index;
    //         for (
    //           let tIndex = 0;
    //           tIndex < boards[index].cards.length;
    //           tIndex++
    //         ) {
    //           if (
    //             boards[index].cards[tIndex].taskId === action.payload.taskId
    //           ) {
    //             taskIndex = tIndex;
    //             break;
    //           }
    //         }
    //       }
    //     }
    //     if (boardIndex > -1 && taskIndex > -1) {
    //       //Task was Found
    //       state.projectBoards.columns[boardIndex].cards[taskIndex] = {
    //         ...action.payload,
    //         taskDocuments: action.payload.taskDocumentsResp,
    //       };
    //     } else if (boardIndex > -1) {
    //       state.projectBoards.columns[boardIndex].cards.unshift({
    //         ...action.payload,
    //         taskDocuments: action.payload.taskDocumentsResp,
    //       });
    //     }
    //   }
    //   return {
    //     ...state,
    //     editTaskLoading: false,
    //     editTaskSuccess: true,
    //     editTaskFailure: false,
    //     editTaskError: null,
    //     // projectBoards: allTasks,
    //     // filteredProjectBoards: allTasks
    //   };
    case TASK_REQUEST.EDIT_TASK_SUCCESS: {
      const updatedTask = {
        ...action.payload,
        taskDocuments: action.payload.taskDocumentsResp,
      };

      const applyUpdateToBoards = (boardsObj) => {
        if (!boardsObj || !Array.isArray(boardsObj.columns)) return boardsObj;

        const nextBoardId = action.payload.currentTaskBoardId;
        const taskId = action.payload.taskId;

        // Find & remove the task from any existing board first
        let removedTask = null;
        for (let i = 0; i < boardsObj.columns.length; i++) {
          const col = boardsObj.columns[i];
          const cards = Array.isArray(col.cards) ? col.cards : [];
          const idx = cards.findIndex((c) => c?.taskId === taskId);
          if (idx > -1) {
            removedTask = cards[idx];
            col.cards.splice(idx, 1);
            // keep counts sane if present
            if (typeof col.totalTask === "number" && col.totalTask > 0) {
              col.totalTask = col.totalTask - 1;
            }
            break;
          }
        }

        // Insert/update into the selected board
        const destCol = boardsObj.columns.find((c) => c?.id === nextBoardId);
        if (!destCol) return boardsObj;
        if (!Array.isArray(destCol.cards)) destCol.cards = [];

        // If it already exists there (edge case), replace it; else unshift
        const existingIdx = destCol.cards.findIndex((c) => c?.taskId === taskId);
        if (existingIdx > -1) {
          destCol.cards[existingIdx] = updatedTask;
        } else {
          destCol.cards.unshift(updatedTask);
          if (typeof destCol.totalTask === "number") {
            destCol.totalTask = destCol.totalTask + 1;
          }
        }

        return boardsObj;
      };

      // Clone to ensure React sees state updates
      const nextProjectBoards = JSON.parse(JSON.stringify(state.projectBoards));
      const nextFilteredBoards = JSON.parse(
        JSON.stringify(state.filteredProjectBoards)
      );

      applyUpdateToBoards(nextProjectBoards);
      applyUpdateToBoards(nextFilteredBoards);

      return {
        ...state,
        editTaskLoading: false,
        editTaskSuccess: true,
        editTaskFailure: false,
        editTaskError: null,
        projectBoards: nextProjectBoards,
        filteredProjectBoards: nextFilteredBoards,
      };
    }
    case TASK_REQUEST.HYDRATE_TASK_DETAIL_SUCCESS: {
      const payload = action.payload || {};
      const taskId = payload.taskId;
      if (!taskId) return state;

      const applyHydration = (boardsObj) => {
        if (!boardsObj || !Array.isArray(boardsObj.columns)) return boardsObj;

        // Determine destination board id if provided (API uses taskBoardId)
        const destBoardId = payload.currentTaskBoardId ?? payload.taskBoardId;

        // Find current column containing the task
        let sourceCol = null;
        let sourceIdx = -1;
        for (let i = 0; i < boardsObj.columns.length; i++) {
          const col = boardsObj.columns[i];
          const cards = Array.isArray(col.cards) ? col.cards : [];
          const idx = cards.findIndex((c) => c?.taskId === taskId);
          if (idx > -1) {
            sourceCol = col;
            sourceIdx = idx;
            break;
          }
        }
        if (!sourceCol || sourceIdx < 0) return boardsObj;

        const existingCard = sourceCol.cards[sourceIdx];
        const hydratedCard = {
          ...existingCard,
          ...payload,
          // normalize core fields from detail API (do not touch comments/worklog/history)
          title: payload.title ?? payload.taskName ?? existingCard.title,
          description:
            payload.description ?? payload.taskDetail ?? existingCard.description,
          currentTaskBoardId:
            payload.currentTaskBoardId ??
            payload.taskBoardId ??
            existingCard.currentTaskBoardId,
          currentAssigneeId:
            payload.currentAssigneeId ??
            payload.assigneeId ??
            existingCard.currentAssigneeId,
        };

        // If board changed and we can find the destination column, move it.
        if (destBoardId && sourceCol.id !== destBoardId) {
          const destCol = boardsObj.columns.find((c) => c?.id === destBoardId);
          if (destCol) {
            sourceCol.cards.splice(sourceIdx, 1);
            if (typeof sourceCol.totalTask === "number" && sourceCol.totalTask > 0) {
              sourceCol.totalTask = sourceCol.totalTask - 1;
            }
            if (!Array.isArray(destCol.cards)) destCol.cards = [];
            destCol.cards.unshift(hydratedCard);
            if (typeof destCol.totalTask === "number") {
              destCol.totalTask = destCol.totalTask + 1;
            }
            return boardsObj;
          }
        }

        // Otherwise just update in place
        sourceCol.cards[sourceIdx] = hydratedCard;
        return boardsObj;
      };

      // Mutate existing board trees in-place so open modal task references
      // keep receiving comment/reply updates by boardIndex/taskIndex.
      applyHydration(state.projectBoards);
      applyHydration(state.filteredProjectBoards);

      return {
        ...state,
        projectBoards: state.projectBoards,
        filteredProjectBoards: state.filteredProjectBoards,
      };
    }
    case TASK_REQUEST.EDIT_TASK_FAILURE:
      return {
        ...state,
        editTaskLoading: false,
        editTaskSuccess: false,
        editTaskFailure: true,
        editTaskError: action.payload,
      };
    case TASK_REQUEST.CHANGE_TASK_STATUS_REQUEST:
      return {
        ...state,
        updateTaskStatusLoading: true,
      };
    case TASK_REQUEST.CHANGE_TASK_STATUS_SUCCESS: {
      const moveCardInBoards = (boardsObj, payload) => {
        if (!boardsObj || !Array.isArray(boardsObj.columns)) return;
        const columns = boardsObj.columns;

        let taskToBeMoved = null;
        let fromColumnIndex = -1;
        let fromCardIndex = -1;

        for (let i = 0; i < columns.length; i++) {
          const cards = Array.isArray(columns[i].cards) ? columns[i].cards : [];
          const foundIdx = cards.findIndex(
            (c) => Number(c?.id) === Number(payload.taskId)
          );
          if (foundIdx > -1) {
            taskToBeMoved = cards[foundIdx];
            fromColumnIndex = i;
            fromCardIndex = foundIdx;
            break;
          }
        }

        if (!taskToBeMoved || fromColumnIndex < 0 || fromCardIndex < 0) return;

        const toColumnIndex = columns.findIndex(
          (c) => Number(c?.id) === Number(payload.statusId)
        );
        if (toColumnIndex < 0) return;

        // Remove from source first
        columns[fromColumnIndex].cards.splice(fromCardIndex, 1);

        const destinationCards = Array.isArray(columns[toColumnIndex].cards)
          ? columns[toColumnIndex].cards
          : (columns[toColumnIndex].cards = []);

        // Keep task board fields in sync for downstream logic
        taskToBeMoved.currentTaskBoardId = payload.statusId;

        // Insert exactly at dropped position instead of appending to end
        const targetIndex =
          payload?.toPosition === 0 || payload?.toPosition
            ? Math.max(0, Math.min(payload.toPosition, destinationCards.length))
            : destinationCards.length;
        destinationCards.splice(targetIndex, 0, taskToBeMoved);
      };

      moveCardInBoards(state.projectBoards, action.payload);
      moveCardInBoards(state.filteredProjectBoards, action.payload);

      return {
        ...state,
        updateTaskStatusSuccess: true,
      };
    }
    case TASK_REQUEST.UPDATE_BOARD_TASK_COUNTS_REQUEST:
      let updatedFilteredProjectBoards = { ...state.filteredProjectBoards };
      // let updatedFilteredProjectBoards
      for (let i = 0; i < updatedFilteredProjectBoards.columns.length; i++) {
        if (
          updatedFilteredProjectBoards.columns[i].id === action.payload.source
        ) {
          updatedFilteredProjectBoards.columns[i].totalTask =
            updatedFilteredProjectBoards.columns[i].totalTask - 1;
        }
        if (
          updatedFilteredProjectBoards.columns[i].id ===
          action.payload.destination
        ) {
          updatedFilteredProjectBoards.columns[i].totalTask =
            updatedFilteredProjectBoards.columns[i].totalTask + 1;
        }
      }
      return {
        ...state,
        filteredProjectBoards: updatedFilteredProjectBoards,
      };
    case TASK_REQUEST.CHANGE_TASK_STATUS_FAILURE:
      return {
        ...state,
        updateTaskStatusFailure: true,
        updateTaskStatusError: action.payload,
      };
    case TASK_REQUEST.CREATE_TASK_REQUEST:
      return {
        ...state,
        addTaskLoading: true,
        addTaskSuccess: false,
        addTaskFailure: false,
        addTaskError: null,
      };
    case TASK_REQUEST.CREATE_TASK_SUCCESS:
      // Insert into both projectBoards + filteredProjectBoards
      // so the UI updates immediately even when creating in non-TODO columns.
      const finalTask = {
        id: action.payload.taskId,
        ...action.payload,
        taskDocuments: action.payload.taskDocumentsResp,
      };

      const targetBoardId = action.payload.currentTaskBoardId;

      const insertInto = (boardsObj) => {
        if (!boardsObj || !Array.isArray(boardsObj.columns)) return boardsObj;
        const col = boardsObj.columns.find(
          (c) => Number(c?.id) === Number(targetBoardId)
        );
        if (!col) return boardsObj;
        if (!Array.isArray(col.cards)) col.cards = [];
        col.cards.unshift(finalTask);
        if (typeof col.totalTask === "number") {
          col.totalTask = col.totalTask + 1;
        }
        return boardsObj;
      };

      const nextProjectBoards = JSON.parse(JSON.stringify(state.projectBoards));
      const nextFilteredBoards = JSON.parse(
        JSON.stringify(state.filteredProjectBoards)
      );

      insertInto(nextProjectBoards);
      insertInto(nextFilteredBoards);
      return {
        ...state,
        addTaskLoading: false,
        addTaskSuccess: true,
        addTaskFailure: false,
        addTaskError: null,
        projectBoards: nextProjectBoards,
        filteredProjectBoards: nextFilteredBoards,
      };
    case TASK_REQUEST.CREATE_TASK_FAILURE:
      return {
        ...state,
        addTaskLoading: false,
        addTaskSuccess: false,
        addTaskFailure: true,
        addTaskError: action.payload,
      };
    case TASK_REQUEST.DELETE_TASK_REQUEST:
      return {
        ...state,
        deleteTaskLoading: true,
        deleteTaskSuccess: false,
        deleteTaskFailure: false,
        deleteTaskError: null,
      };
    case TASK_REQUEST.DELETE_TASK_SUCCESS:
      let allTasks = JSON.parse(JSON.stringify(state.projectBoards));

      if (allTasks.columns && allTasks.columns.length > 0) {
        allTasks.columns.forEach((column) => {
          column.cards = column.cards.filter(
            (card) => card.id !== action.payload
          );
        });
      }

      return {
        ...state,
        deleteTaskLoading: false,
        deleteTaskSuccess: true,
        deleteTaskFailure: false,
        deleteTaskError: null,
        projectBoards: allTasks,
        filteredProjectBoards: allTasks,
      };

    case TASK_REQUEST.DELETE_TASK_FAILURE:
      return {
        ...state,
        deleteTaskLoading: false,
        deleteTaskSuccess: false,
        deleteTaskFailure: true,
        deleteTaskError: action.payload,
      };

    case TASK_REQUEST.UPDATE_BULK_TASK_REQUEST:
      return {
        ...state,
        updateBulkLoading: true,
        updateBulkSuccess: false,
        updateBulkFailure: false,
        updateBulkError: null,
      };

    case TASK_REQUEST.UPDATE_BULK_TASK_SUCCESS:
      return {
        ...state,
        updateBulkLoading: false,
        updateBulkSuccess: true,
        updateBulkFailure: false,
        updateBulkError: null,
      };

    case TASK_REQUEST.UPDATE_BULK_TASK_FAILURE:
      return {
        ...state,
        updateBulkLoading: false,
        updateBulkSuccess: false,
        updateBulkFailure: true,
        updateBulkError: action.payload,
      };

    case TASK_REQUEST.DELETE_TASK_BOARD_REQUEST:
      return {
        ...state,
        deleteTaskboardLoading: true,
        deleteTaskboardSuccess: false,
        deleteTaskboardFailure: false,
        deleteTaskboardError: null,
      };
    case TASK_REQUEST.DELETE_TASK_BOARD_SUCCESS:
      let oBoards = state.projectBoards;
      for (let i = 0; i < oBoards.columns.length; i++) {
        if (oBoards.columns[i].id === action.payload) {
          oBoards.columns.splice(i, 1);
        }
      }
      return {
        ...state,
        deleteTaskboardLoading: false,
        deleteTaskboardSuccess: true,
        deleteTaskboardFailure: false,
        deleteTaskboardError: null,
        projectBoards: oBoards,
        filteredProjectBoards: oBoards,
      };
    case TASK_REQUEST.DELETE_TASK_BOARD_FAILURE:
      return {
        ...state,
        deleteTaskboardLoading: false,
        deleteTaskboardSuccess: false,
        deleteTaskboardFailure: true,
        deleteTaskboardError: action.payload,
      };
    case TASK_REQUEST.FILTER_BY_SEVERITY:
      let severity = action.payload;
      let all_boards = state.projectBoards;
      let new_cols = [];
      for (let x = 0; x < all_boards.columns.length; x++) {
        let new_cards = [];
        for (let y = 0; y < all_boards.columns[x].cards.length; y++) {
          if (all_boards.columns[x].cards[y].severityId === severity) {
            new_cards.push(all_boards.columns[x].cards[y]);
          }
        }
        new_cols.push({
          ...all_boards.columns[x],
          cards: new_cards,
        });
      }
      return {
        ...state,
        filteredProjectBoards: { columns: new_cols },
      };
    case TASK_REQUEST.FILTER_BY_ASSIGNEE:
      let assignee = action.payload;
      let all_boards_ = state.projectBoards;
      let new_cols_ = [];
      for (let x = 0; x < all_boards_.columns.length; x++) {
        let new_cards = [];
        for (let y = 0; y < all_boards_.columns[x].cards.length; y++) {
          if (all_boards_.columns[x].cards[y].assigneeId === assignee) {
            new_cards.push(all_boards_.columns[x].cards[y]);
          }
        }
        new_cols_.push({
          ...all_boards_.columns[x],
          cards: new_cards,
        });
      }
      return {
        ...state,
        filteredProjectBoards: { columns: new_cols_ },
      };
    case TASK_REQUEST.FILTER_BY_ME:
      let me = action.payload;
      let myTasks = state.projectBoards;
      let new_columns = [];
      for (let x = 0; x < myTasks.columns.length; x++) {
        let new_cards = [];
        for (let y = 0; y < myTasks.columns[x].cards.length; y++) {
          if (myTasks.columns[x].cards[y].reportedById === me) {
            new_cards.push(myTasks.columns[x].cards[y]);
          }
        }
        new_columns.push({
          ...myTasks.columns[x],
          cards: new_cards,
        });
      }
      return {
        ...state,
        filteredProjectBoards: { columns: new_columns },
      };
    case TASK_REQUEST.FILTER_BY_PRIORITY:
      allTasks = state.projectBoards;
      new_col = [];
      for (let x = 0; x < allTasks.columns.length; x++) {
        let new_cards = [];
        new_cards = allTasks.columns[x].cards.sort((a, b) =>
          a.severityId > b.severityId ? 1 : b.severityId > a.severityId ? -1 : 0
        );
        new_col.push({
          ...allTasks.columns[x],
          cards: new_cards,
        });
      }
      return {
        ...state,
        filteredProjectBoards: { columns: new_col },
      };
    case TASK_REQUEST.FILTER_BY_CREATED_DATE:
      allTasks = state.projectBoards;
      new_col = [];
      for (let x = 0; x < allTasks.columns.length; x++) {
        let new_cards = [];
        new_cards = allTasks.columns[x].cards.sort(
          (a, b) =>
            new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime()
        );
        new_col.push({
          ...allTasks.columns[x],
          cards: new_cards,
        });
      }
      return {
        ...state,
        filteredProjectBoards: { columns: new_col },
      };
    case TASK_REQUEST.CLEAR_FILTER:
      return {
        ...state,
        filteredProjectBoards: state.projectBoards,
      };
    case TASK_REQUEST.PROJECT_SELECTED:
      return {
        ...state,
        selectedProject: action.payload,
      };
    case TASK_REQUEST.OPEN_INVITE_MODAL:
      return {
        ...state,
        inviteModal: true,
      };
    case TASK_REQUEST.CLOSE_INVITE_MODAL:
      return {
        ...state,
        inviteModal: false,
      };
    case TASK_REQUEST.MOVE_KANBAN_COLUMN:
      const { source, dest } = action.payload;

      const newColumns = [...state.projectBoards.columns]; // Create a new array reference
      const [movedColumn] = newColumns.splice(source, 1); // Remove the column from the source
      newColumns.splice(dest, 0, movedColumn); // Insert it at the destination

      return {
        ...state,
        projectBoards: {
          ...state.projectBoards,
          columns: newColumns, // Update columns immutably
        },
        filteredProjectBoards: {
          ...state.filteredProjectBoards,
          columns: newColumns,
        },
      };

    case TASK_REQUEST.SEND_INVITE_REQUEST:
      return {
        ...state,
        sendInviteLoading: true,
        sendInviteSuccess: false,
        sendInviteFailure: false,
      };
    case TASK_REQUEST.SEND_INVITE_SUCCESS:
      return {
        ...state,
        sendInviteLoading: false,
        sendInviteSuccess: true,
        sendInviteFailure: false,
        sendInviteError: null,
      };
    case TASK_REQUEST.SEND_INVITE_FAILURE:
      return {
        ...state,
        sendInviteLoading: false,
        sendInviteSuccess: false,
        sendInviteFailure: true,
        sendInviteError: action.payload,
      };
    case TASK_REQUEST.USER_LIST_INVITE_REQUEST:
      return {
        ...state,
        userListForInviteLoading: true,
        userListForInviteSuccess: false,
        userListForInviteFailure: false,
        userListForInviteError: null,
      };

    case TASK_REQUEST.USER_LIST_INVITE_SUCCESS:
      return {
        ...state,
        userListForInviteLoading: false,
        userListForInviteSuccess: true,
        userListForInviteFailure: false,
        userListforInvites: action.payload,
      };
    case TASK_REQUEST.USER_LIST_INVITE_FAILURE:
      return {
        ...state,
        userListForInviteLoading: false,
        userListForInviteSuccess: false,
        userListForInviteFailure: true,
        userListForInviteError: action.payload,
      };
    case TASK_REQUEST.REMOVE_USER_FROM_PROJECT_REQUEST:
      return {
        ...state,
        removeEmployeeLoading: true,
        removeEmployeeSuccess: false,
        removeEmployeeFailure: false,
        removeEmployeeError: null,
      };
    case TASK_REQUEST.REMOVE_USER_FROM_PROJECT_SUCCESS:
      let teamMembers = state?.selectedProject?.projectTeamMembers?.filter(
        (e) => e.userId != 248
      );
      return {
        ...state,
        removeEmployeeLoading: false,
        removeEmployeeSuccess: true,
        removeEmployeeFailure: false,
        removeEmployeeError: null,
        selectedProject: { projectTeamMembers: teamMembers },
      };

    case TASK_REQUEST.REMOVE_USER_FROM_PROJECT_FAILURE:
      return {
        ...state,
        removeEmployeeLoading: false,
        removeEmployeeSuccess: false,
        removeEmployeeFailure: true,
        removeEmployeeError: action.payload,
      };
    case TASK_REQUEST.GET_QA_TEMPLATE_REQUEST:
      return {
        ...state,
        getQaTemplateLoading: true,
        getQaTemplateSuccess: false,
        getQaTemplateFailure: false,
        getQaTemplateError: null,
      };
    case TASK_REQUEST.GET_QA_TEMPLATE_SUCCESS:
      return {
        ...state,
        getQaTemplateLoading: false,
        getQaTemplateSuccess: true,
        getQaTemplateFailure: false,
        getQaTemplateError: null,
        QaTemplates: action.payload,
      };
    case TASK_REQUEST.GET_QA_TEMPLATE_FAILURE:
      return {
        ...state,
        getQaTemplateLoading: false,
        getQaTemplateSuccess: false,
        getQaTemplateFailure: true,
        getQaTemplateError: action.payload,
      };
    case TASK_REQUEST.ADD_QA_TEMPLATE_REQUEST:
      return {
        ...state,
        addQaTemplateLoading: true,
        addQaTemplateSuccess: false,
        addQaTemplateFailure: false,
        addQaTemplateError: null,
      };
    case TASK_REQUEST.ADD_QA_TEMPLATE_SUCCESS:
      state.QaTemplates.unshift(action.payload);
      return {
        ...state,
        addQaTemplateLoading: false,
        addQaTemplateSuccess: true,
        addQaTemplateFailure: false,
        addQaTemplateError: null,
      };
    case TASK_REQUEST.ADD_QA_TEMPLATE_FAILURE:
      return {
        ...state,
        addQaTemplateLoading: false,
        addQaTemplateSuccess: false,
        addQaTemplateFailure: true,
        addQaTemplateError: action.payload,
      };

    case TASK_REQUEST.UPDATE_QA_TEMPLATE_REQUEST:
      return {
        ...state,
        updateQaTemplateLoading: true,
        updateQaTemplateSuccess: false,
        updateQaTemplateFailure: false,
        updateQaTemplateError: null,
      };

    case TASK_REQUEST.UPDATE_QA_TEMPLATE_SUCCESS:
      for (let i = 0; i < action.payload.ids.length; i++) {
        for (let j = 0; j < state.QaTemplates.length; j++) {
          if (state.QaTemplates[j].testCaseId === action.payload.ids[i])
            state.QaTemplates[j].status =
              action.payload.status === 0 ? "FAIL" : "PASS";
        }
      }
      return {
        ...state,
        updateQaTemplateLoading: false,
        updateQaTemplateSuccess: true,
        updateQaTemplateFailure: false,
        updateQaTemplateError: null,
      };
    case TASK_REQUEST.UPDATE_QA_TEMPLATE_FAILURE:
      return {
        ...state,
        updateQaTemplateLoading: false,
        updateQaTemplateSuccess: false,
        updateQaTemplateFailure: true,
        updateQaTemplateError: null,
      };

    case TASK_REQUEST.REMOVE_QA_TEMPLATE_REQUEST:
      return {
        ...state,
        deleteQaTemplateLoading: true,
        deleteQaTemplateSuccess: false,
        deleteQaTemplateFailure: false,
        deleteQaTemplateError: null,
      };
    case TASK_REQUEST.REMOVE_QA_TEMPLATE_SUCCESS:
      qa = state.QaTemplates;
      for (var i = 0; i < qa.length; i++) {
        if (qa[i].testCaseId === action.payload) {
          state.QaTemplates.splice(i, 1);
        }
      }
      return {
        ...state,
        deleteQaTemplateLoading: false,
        deleteQaTemplateSuccess: true,
        deleteQaTemplateFailure: false,
        deleteQaTemplateError: null,
      };
    case TASK_REQUEST.REMOVE_QA_TEMPLATE_FAILURE:
      return {
        ...state,
        deleteQaTemplateLoading: false,
        deleteQaTemplateSuccess: false,
        deleteQaTemplateFailure: true,
        deleteQaTemplateError: action.payload,
      };
    case TASK_REQUEST.GET_COMMENT_IN_KANBAN_SUCCESS:
      {
        const findTaskPosition = (boardsObj, info) => {
          if (!boardsObj?.columns) return null;
          if (info?.taskId) {
            const lookupTaskId = Number(info.taskId);
            for (let i = 0; i < boardsObj.columns.length; i++) {
              const cards = boardsObj.columns[i]?.cards || [];
              const idx = cards.findIndex(
                (c) => Number(c?.taskId) === lookupTaskId
              );
              if (idx > -1) return { boardIndex: i, taskIndex: idx };
            }
          }
          if (
            info &&
            info.boardIndex >= 0 &&
            info.taskIndex >= 0 &&
            boardsObj.columns[info.boardIndex]?.cards?.[info.taskIndex]
          ) {
            return { boardIndex: info.boardIndex, taskIndex: info.taskIndex };
          }
          return null;
        };

        const posA = findTaskPosition(state.projectBoards, action.info);
        const posB = findTaskPosition(state.filteredProjectBoards, action.info);

        const latestComments = Array.isArray(action.payload) ? action.payload : [];
        if (posA) {
          state.projectBoards.columns[posA.boardIndex].cards[posA.taskIndex].comments =
            latestComments;
        }
        if (posB) {
          state.filteredProjectBoards.columns[posB.boardIndex].cards[
            posB.taskIndex
          ].comments = latestComments;
        }
      }
      return {
        ...state,
        getCommentInKanbanSuccess: true,
      };
    case TASK_REQUEST.ADD_COMMENT_IN_KANBAN_SUCCESS:
      return {
        ...state,
        addCommentInKanbanSuccess: true,
      };
    //delete comment
    case TASK_REQUEST.DELETE_COMMENT_IN_KANBAN_SUCCESS:
      return {
        ...state,
        deleteCommentInKanbanSuccess: true,
      };
    case TASK_REQUEST.GET_TASK_WORKHISTORY_SUCCESS:
      if (action.payload != null) {
        state.TaskHistory = [...action.payload];
      }
      return {
        ...state,
        getTaskWorkHistorySuccess: true,
        getTaskWorkHistoryFailure: false,
        getTaskWorkHistoryLoading: false,
        getTaskWorkHistoryError: null,
      };
    case TASK_REQUEST.GET_TASK_WORKLOG_SUCCESS:
      if (action.payload != null) {
        state.TaskWorkLog = action.payload;
      }
      return {
        ...state,
        getTaskWorkLogSuccess: true,
        getTaskWorkLogFailure: false,
        getTaskWorkLogLoading: false,
        getTaskWorkLogError: null,
      };
    case TASK_REQUEST.GET_TASK_WORKLOG_REQUEST:
      return {
        ...state,
        getTaskWorkLogSuccess: false,
        getTaskWorkLogFailure: false,
        getTaskWorkLogLoading: true,
        getTaskWorkLogError: null,
      };
    case TASK_REQUEST.GET_TASK_WORKLOG_FAILURE:
      return {
        ...state,
        getTaskWorkLogSuccess: false,
        getTaskWorkLogFailure: true,
        getTaskWorkLogLoading: false,
        getTaskWorkLogError: null,
      };
    //add worklog
    case TASK_REQUEST.ADD_TASK_WORKLOG_SUCCESS:
      if (action.payload != null) {
        state.projectBoards.columns[action.info.outerIndex].cards[
          action.info.innerIndex
        ].totalTimeSpent = action.payload.totalTimeSpent;
      }
      return {
        ...state,
        addTaskWorkLogSuccess: true,
        addTaskWorkLogFailure: false,
        addTaskWorkLogLoading: false,
        addTaskWorkLogError: null,
      };
    case TASK_REQUEST.ADD_TASK_WORKLOG_REQUEST:
      return {
        ...state,
        addTaskWorkLogSuccess: false,
        addTaskWorkLogFailure: false,
        addTaskWorkLogLoading: true,
        addTaskWorkLogError: null,
      };
    case TASK_REQUEST.ADD_TASK_WORKLOG_FAILURE:
      return {
        ...state,
        addTaskWorkLogSuccess: false,
        addTaskWorkLogFailure: true,
        addTaskWorkLogLoading: false,
        addTaskWorkLogError: null,
      };
    //Delete Task Attachment
    case TASK_REQUEST.DELETE_TASK_ATTACHMENT_REQUEST:
      return {
        ...state,
        deleteTaskAttachmentSuccess: false,
        deleteTaskAttachmentLoading: true,
        deleteTaskAttachmentFailure: false,
        deleteTaskAttachmentError: null,
      };
    case TASK_REQUEST.DELETE_TASK_ATTACHMENT_SUCCESS:
      if (action.payload != null) {
        let fileIndex = state.projectBoards.columns[
          action.info.boardIndex
        ].cards[action.info.taskIndex].taskDocuments.findIndex(
          (x) => x.taskDocumentId === action.info.attachmentId
        );
        state.projectBoards.columns[action.info.boardIndex].cards[
          action.info.taskIndex
        ].taskDocuments.splice(fileIndex, 1);
      }
      return {
        ...state,
        deleteTaskAttachmentSuccess: true,
        deleteTaskAttachmentLoading: false,
        deleteTaskAttachmentFailure: false,
        deleteTaskAttachmentError: null,
      };
    case TASK_REQUEST.DELETE_TASK_ATTACHMENT_FAILURE:
      return {
        ...state,
        deleteTaskAttachmentSuccess: false,
        deleteTaskAttachmentLoading: false,
        deleteTaskAttachmentFailure: true,
        deleteTaskAttachmentError: null,
      };
    case TASK_REQUEST.TASK_RESET_PARTIAL_STATE:
      return {
        ...state,
        editTaskLoading: false,
        editTaskSuccess: false,
        editTaskFailure: false,
        editTaskError: null,

        updateTaskStatusLoading: false,
        updateTaskStatusSuccess: false,
        updateTaskStatusFailure: false,
        updateTaskStatusError: null,

        addTaskLoading: false,
        addTaskSuccess: false,
        addTaskFailure: false,
        addTaskError: null,

        deleteTaskLoading: false,
        deleteTaskSuccess: false,
        deleteTaskFaiure: false,
        deleteTaskError: null,

        sentInviteLoading: false,
        sendInviteSuccess: false,
        sentInviteFailure: false,
        sendInviteError: null,

        userListForInviteLoading: false,
        userListForInviteSuccess: false,
        userListForInviteFailure: false,
        userListForInviteError: null,

        addQaTemplateLoading: false,
        addQaTemplateSuccess: false,
        addQaTemplateFailure: false,
        addQaTemplateError: null,

        deleteQaTemplateLoading: false,
        deleteQaTemplateSuccess: false,
        deleteQaTemplateFailure: false,
        deleteQaTemplateError: null,
      };
    case "ADD_BUTTON_CLICK":
      return {
        ...state,
        addTaskModals: action.payload,
      };
    default:
      return state;
  }
};
